import actor from './Actor';
import layout from './layout';

const getRoutes = () => ({ actor, layout });

export default getRoutes;
